<script setup>
import { computed } from 'vue'

const props = defineProps({
  currentPage: { type: Number, default: 1 },
  perPage: { type: Number, default: 10 },
  lastPage: { type: Number, default: 1 },
  total: { type: Number, default: 1 },
  goToFirst: Function,
  goToLast: Function,
  previous: Function,
  next: Function,
})

const isFirstPage = computed(() => props.currentPage == 1)
const isLastPage = computed(() => props.currentPage === props.lastPage)
</script>

<template>
  <div class="d-flex justify-content-center align-items-center px-8 py-5">
    <span class="me-5">
      {{ $t('mail.message_of') }}
      {{ ((currentPage - 1) * perPage) + 1 }}
      {{ $t('mail.to') }}
      {{ Math.min(currentPage * perPage, total) }}
      {{ $t('mail.on') }}
      {{ total }}
    </span>

    <div class="btn-group" role="group" aria-label="Pagination">
      <button
          type="button"
          class="btn btn-sm p-2"
          @click.prevent="goToFirst"
          :disabled="isFirstPage"
          :style="{ backgroundColor: '#eef3f7'}"
          style="border-top-left-radius: 5px; border-bottom-left-radius: 5px;"
      >
        <i class="fa fa-step-backward" :class="{ 'active-action': !isFirstPage }"></i>
      </button>

      <button
          type="button"
          class="btn btn-sm p-2"
          @click.prevent="previous"
          :disabled="isFirstPage"
          :style="{ backgroundColor: '#eef3f7'}"
      >
        <i class="fa fa-caret-left fs-2" :class="{ 'active-action': !isFirstPage }"></i>
      </button>

      <button
          type="button"
          class="btn btn-sm p-2"
          @click.prevent="next"
          :disabled="isLastPage"
          :style="{ backgroundColor: '#eef3f7'}"
      >
        <i class="fa fa-caret-right fs-2" :class="{ 'active-action': !isLastPage }"></i>
      </button>

      <button
          type="button"
          class="btn btn-sm p-2"
          @click.prevent="goToLast"
          :disabled="isLastPage"
          :style="{ backgroundColor: '#eef3f7'}"
          style="border-top-right-radius: 5px; border-bottom-right-radius: 5px;"
      >
        <i class="fa fa-step-forward" :class="{ 'active-action': !isLastPage }"></i>
      </button>
    </div>
  </div>
</template>

<style scoped>
.active-action {
  color: #303D4E;
}
</style>
